import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { getAllVideoGraphers } from 'dashboard/_redux/actions/users';
import CRUDDataTable from 'dashboard/containers/CRUDDataTable';
import { useVideoGrapherList } from './useVideoGrapherList';

const VideoGrapherList: React.FC = () => {
  const { videoGraphers, loaded, dataTableRef, columns } = useVideoGrapherList();

  const [t] = useTranslation();

  return (
    <div className="card card-body">
      <CRUDDataTable
        myRef={dataTableRef}
        loading={!loaded}
        data={videoGraphers}
        title={`${t('dashboard.videoGrapherPage.title')}`}
        columns={columns}
        fetchDataFn={getAllVideoGraphers}
      />
    </div>
  );
};

export default VideoGrapherList;
